/**
 * @Author: DJ
 * @Date:   2022-06-06 15:55:21
 * @Last Modified by:   DJ
 * @Last Modified time: 2022-06-06 17:43:52
 */

 import http from '@/assets/api/http';

 // 收款单列表
 export async function TransportSettleModeEnum(params){
     return http('/?cmd=com.xqxc.pig.enums.platform.TransportSettleModeEnum',params,'POST');
 }

 // 小运力公司列表
 export async function smallTransportList(params){
    return http('/?cmd=com.xqxc.api.pig.mis.biz.account.SmallTransportMisService.smallTransportList',params,'POST');
}
